const MagnifyingGlass = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M7.16448 13.329C10.569 13.329 13.329 10.569 13.329 7.16448C13.329 3.75993 10.569 1 7.16448 1C3.75993 1 1 3.75993 1 7.16448C1 10.569 3.75993 13.329 7.16448 13.329Z"
        stroke="#7B858B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0001 15.0001L11.5146 11.5146"
        stroke="#7B858B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MagnifyingGlass;
